export default __webpack_public_path__ + "780330413aa5baf904a82986f462d321.png";